export default "__VITE_ASSET__BtCNCTle__"